import styled from "styled-components";
import theme from "../../theme/theme";

export const QuestionnaireTitle = styled.h1`
  color: ${theme.colors.primaryStrong};
  font-weight: 500;
  text-align: left;

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;
